// Q3G (Q3 Guidance) weekly CPLH plan rates for OLM1, Q4 2026 — the rates locked
// with Finance. Source: "October Q3G Ramp.xlsx" (sheet Q3G, "Q3G CPLH Rates"
// block) and "NSXD LTC - Updated FCLM Q4.xlsx" (function -> PPR line mapping,
// updated for Project Mercury). Provided by Jenna Brechbuhler, 2026-10-01.
//
// Rates are cartons per labor hour at the PPR line-item level, keyed by PPID.
// Totals: 602 Total Inbound, 604 Transfer-Out, 609 THROUGHPUT (= diluted CPLH,
// numerator IB + OB cartons — same convention Jar Jar uses everywhere).
//
// How LVP uses this (rateSource === 'q3g'): for each PPR line, target hours =
// line volume / Q3G rate; the B3of4 hours of the functions mapped to that line
// are scaled proportionally to hit the target. Functions whose line is not in
// Q3G keep their B3of4 rate. Manual overrides always win.

export const Q3G_WEEKS = ["2026-10-04", "2026-10-11", "2026-10-18", "2026-10-25", "2026-11-01", "2026-11-08", "2026-11-15", "2026-11-22", "2026-11-29", "2026-12-06", "2026-12-13", "2026-12-20"];

export const Q3G_LINES = {
  '1': { name: "Receive Dock", rates: { '2026-10-04': 165.73, '2026-10-11': 167.83, '2026-10-18': 169.92, '2026-10-25': 172.01, '2026-11-01': 169.95, '2026-11-08': 169.97, '2026-11-15': 172.07, '2026-11-22': 174.16, '2026-11-29': 177.3, '2026-12-06': 175.91, '2026-12-13': 178.02, '2026-12-20': 191.94 } },
  '2': { name: "Each Receive - Small", rates: { '2026-10-04': 1.99, '2026-10-11': 2.01, '2026-10-18': 2.04, '2026-10-25': 2.07, '2026-11-01': 2.04, '2026-11-08': 2.04, '2026-11-15': 2.07, '2026-11-22': 2.1, '2026-11-29': 2.12, '2026-12-06': 2.1, '2026-12-13': 2.13, '2026-12-20': 2.29 } },
  '3': { name: "Each Receive - Medium", rates: { '2026-10-04': 53.07, '2026-10-11': 53.71, '2026-10-18': 54.35, '2026-10-25': 54.98, '2026-11-01': 54.07, '2026-11-08': 54.07, '2026-11-15': 54.71, '2026-11-22': 55.35, '2026-11-29': 55.99, '2026-12-06': 55.64, '2026-12-13': 56.28, '2026-12-20': 60.71 } },
  '4': { name: "Each Receive - Large", rates: { '2026-10-04': 33.43, '2026-10-11': 33.81, '2026-10-18': 34.19, '2026-10-25': 34.57, '2026-11-01': 33.85, '2026-11-08': 33.85, '2026-11-15': 34.23, '2026-11-22': 34.61, '2026-11-29': 35.0, '2026-12-06': 34.84, '2026-12-13': 35.22, '2026-12-20': 38.01 } },
  '5': { name: "Each Receive - Heavy/Bulky", rates: { '2026-10-04': 33.59, '2026-10-11': 33.97, '2026-10-18': 34.35, '2026-10-25': 34.74, '2026-11-01': 34.01, '2026-11-08': 34.01, '2026-11-15': 34.4, '2026-11-22': 34.78, '2026-11-29': 35.17, '2026-12-06': 35.0, '2026-12-13': 35.38, '2026-12-20': 38.19 } },
  '10': { name: "Case Receive", rates: { '2026-10-04': 6.97, '2026-10-11': 7.01, '2026-10-18': 7.04, '2026-10-25': 7.08, '2026-11-01': 6.63, '2026-11-08': 6.63, '2026-11-15': 6.66, '2026-11-22': 6.7, '2026-11-29': 6.75, '2026-12-06': 6.82, '2026-12-13': 6.85, '2026-12-20': 7.44 } },
  '11': { name: "LP Receive", rates: { '2026-10-04': 1451.69, '2026-10-11': 1470.41, '2026-10-18': 1489.14, '2026-10-25': 1507.86, '2026-11-01': 1534.22, '2026-11-08': 1534.41, '2026-11-15': 1553.13, '2026-11-22': 1571.86, '2026-11-29': 1590.58, '2026-12-06': 1578.71, '2026-12-13': 1597.44, '2026-12-20': 1676.39 } },
  '12': { name: "Pallet Receive", rates: { '2026-10-04': 14.66, '2026-10-11': 14.85, '2026-10-18': 15.04, '2026-10-25': 15.23, '2026-11-01': 15.08, '2026-11-08': 15.08, '2026-11-15': 15.27, '2026-11-22': 15.46, '2026-11-29': 15.65, '2026-12-06': 15.52, '2026-12-13': 15.71, '2026-12-20': 16.93 } },
  '13': { name: "Receive Support", rates: { '2026-10-04': 216.27, '2026-10-11': 219.02, '2026-10-18': 221.77, '2026-10-25': 224.52, '2026-11-01': 222.0, '2026-11-08': 222.02, '2026-11-15': 224.77, '2026-11-22': 227.52, '2026-11-29': 230.27, '2026-12-06': 228.43, '2026-12-13': 231.19, '2026-12-20': 249.26 } },
  '19': { name: "Case Transfer In", rates: { '2026-10-04': 393.21, '2026-10-11': 398.24, '2026-10-18': 403.25, '2026-10-25': 408.25, '2026-11-01': 404.01, '2026-11-08': 404.15, '2026-11-15': 409.16, '2026-11-22': 414.14, '2026-11-29': 419.24, '2026-12-06': 415.73, '2026-12-13': 420.87, '2026-12-20': 453.64 } },
  '21': { name: "Transfer In Support", rates: { '2026-10-04': 393.21, '2026-10-11': 398.24, '2026-10-18': 403.25, '2026-10-25': 408.25, '2026-11-01': 404.01, '2026-11-08': 404.15, '2026-11-15': 409.16, '2026-11-22': 414.14, '2026-11-29': 419.24, '2026-12-06': 415.73, '2026-12-13': 420.87, '2026-12-20': 453.64 } },
  '22': { name: "Cubiscan", rates: { '2026-10-04': 5.34, '2026-10-11': 5.36, '2026-10-18': 5.38, '2026-10-25': 5.4, '2026-11-01': 4.96, '2026-11-08': 4.96, '2026-11-15': 4.97, '2026-11-22': 4.99, '2026-11-29': 5.01, '2026-12-06': 5.1, '2026-12-13': 5.12, '2026-12-20': 5.56 } },
  '24': { name: "Prep Recorder - Small", rates: { '2026-10-04': 23.8, '2026-10-11': 24.1, '2026-10-18': 24.41, '2026-10-25': 24.72, '2026-11-01': 24.48, '2026-11-08': 24.49, '2026-11-15': 24.79, '2026-11-22': 25.11, '2026-11-29': 25.41, '2026-12-06': 25.2, '2026-12-13': 25.5, '2026-12-20': 27.49 } },
  '25': { name: "Prep Recorder - Medium", rates: { '2026-10-04': 23.8, '2026-10-11': 24.1, '2026-10-18': 24.41, '2026-10-25': 24.72, '2026-11-01': 24.48, '2026-11-08': 24.49, '2026-11-15': 24.79, '2026-11-22': 25.11, '2026-11-29': 25.41, '2026-12-06': 25.2, '2026-12-13': 25.5, '2026-12-20': 27.49 } },
  '26': { name: "Prep Recorder - Large", rates: { '2026-10-04': 23.8, '2026-10-11': 24.1, '2026-10-18': 24.41, '2026-10-25': 24.72, '2026-11-01': 24.48, '2026-11-08': 24.49, '2026-11-15': 24.79, '2026-11-22': 25.11, '2026-11-29': 25.41, '2026-12-06': 25.2, '2026-12-13': 25.5, '2026-12-20': 27.49 } },
  '27': { name: "Prep Recorder - Heavy/Bulky", rates: { '2026-10-04': 23.8, '2026-10-11': 24.1, '2026-10-18': 24.41, '2026-10-25': 24.72, '2026-11-01': 24.48, '2026-11-08': 24.49, '2026-11-15': 24.79, '2026-11-22': 25.11, '2026-11-29': 25.41, '2026-12-06': 25.2, '2026-12-13': 25.5, '2026-12-20': 27.49 } },
  '28': { name: "Prep Support", rates: { '2026-10-04': 7616.76, '2026-10-11': 7616.76, '2026-10-18': 7616.76, '2026-10-25': 7616.76, '2026-11-01': 7616.76, '2026-11-08': 7616.76, '2026-11-15': 7616.76, '2026-11-22': 7616.76, '2026-11-29': 7616.76, '2026-12-06': 7616.76, '2026-12-13': 7616.76, '2026-12-20': 7616.76 } },
  '40': { name: "RSR Support", rates: { '2026-10-04': 7624.39, '2026-10-11': 7624.39, '2026-10-18': 7624.39, '2026-10-25': 7624.39, '2026-11-01': 7624.39, '2026-11-08': 7624.39, '2026-11-15': 7624.39, '2026-11-22': 7624.39, '2026-11-29': 7624.39, '2026-12-06': 7624.39, '2026-12-13': 7624.39, '2026-12-20': 7624.39 } },
  '41': { name: "IB Lead/PA", rates: { '2026-10-04': 1002.68, '2026-10-11': 1015.58, '2026-10-18': 1028.47, '2026-10-25': 1041.36, '2026-11-01': 1030.85, '2026-11-08': 1030.98, '2026-11-15': 1043.88, '2026-11-22': 1056.77, '2026-11-29': 1069.66, '2026-12-06': 1060.74, '2026-12-13': 1073.64, '2026-12-20': 1157.42 } },
  '42': { name: "IB Problem Solve", rates: { '2026-10-04': 679.13, '2026-10-11': 687.83, '2026-10-18': 696.53, '2026-10-25': 705.24, '2026-11-01': 697.91, '2026-11-08': 698.0, '2026-11-15': 706.7, '2026-11-22': 715.41, '2026-11-29': 724.12, '2026-12-06': 718.15, '2026-12-13': 726.86, '2026-12-20': 783.6 } },
  '56': { name: "Transfer Out", rates: { '2026-10-04': 62.76, '2026-10-11': 63.49, '2026-10-18': 64.22, '2026-10-25': 64.94, '2026-11-01': 63.68, '2026-11-08': 63.69, '2026-11-15': 64.41, '2026-11-22': 65.14, '2026-11-29': 65.87, '2026-12-06': 65.52, '2026-12-13': 66.25, '2026-12-20': 71.49 } },
  '57': { name: "Transfer Out Dock", rates: { '2026-10-04': 279.94, '2026-10-11': 283.48, '2026-10-18': 287.02, '2026-10-25': 290.56, '2026-11-01': 287.15, '2026-11-08': 287.19, '2026-11-15': 290.73, '2026-11-22': 294.26, '2026-11-29': 297.81, '2026-12-06': 295.48, '2026-12-13': 299.02, '2026-12-20': 322.41 } },
  '58': { name: "TO Lead/PA", rates: { '2026-10-04': 1055.41, '2026-10-11': 1068.98, '2026-10-18': 1082.56, '2026-10-25': 1096.14, '2026-11-01': 1085.1, '2026-11-08': 1085.24, '2026-11-15': 1098.82, '2026-11-22': 1112.4, '2026-11-29': 1125.98, '2026-12-06': 1116.58, '2026-12-13': 1130.15, '2026-12-20': 1218.33 } },
  '59': { name: "TO Problem Solve", rates: { '2026-10-04': 5010.18, '2026-10-11': 5074.94, '2026-10-18': 5139.71, '2026-10-25': 5204.49, '2026-11-01': 5154.56, '2026-11-08': 5155.21, '2026-11-15': 5219.98, '2026-11-22': 5284.75, '2026-11-29': 5349.52, '2026-12-06': 5304.04, '2026-12-13': 5368.82, '2026-12-20': 5787.44 } },
  '126': { name: "Admin/HR/IT", rates: { '2026-10-04': 284.92, '2026-10-11': 284.89, '2026-10-18': 285.66, '2026-10-25': 290.21, '2026-11-01': 296.77, '2026-11-08': 297.07, '2026-11-15': 297.04, '2026-11-22': 296.24, '2026-11-29': 282.32, '2026-12-06': 261.93, '2026-12-13': 259.43, '2026-12-20': 260.88 } },
  '602': { name: "Total Inbound", rates: { '2026-10-04': 61.65, '2026-10-11': 62.41, '2026-10-18': 63.18, '2026-10-25': 63.96, '2026-11-01': 63.3, '2026-11-08': 63.3, '2026-11-15': 64.08, '2026-11-22': 64.85, '2026-11-29': 65.76, '2026-12-06': 65.25, '2026-12-13': 66.01, '2026-12-20': 71.02 } },
  '604': { name: "Transfer-Out", rates: { '2026-10-04': 48.42, '2026-10-11': 48.99, '2026-10-18': 49.57, '2026-10-25': 50.14, '2026-11-01': 49.26, '2026-11-08': 49.26, '2026-11-15': 49.83, '2026-11-22': 50.41, '2026-11-29': 50.98, '2026-12-06': 50.68, '2026-12-13': 51.26, '2026-12-20': 55.3 } },
  '607': { name: "Support", rates: { '2026-10-04': 282.09, '2026-10-11': 282.07, '2026-10-18': 282.83, '2026-10-25': 287.33, '2026-11-01': 293.83, '2026-11-08': 294.13, '2026-11-15': 294.1, '2026-11-22': 293.3, '2026-11-29': 279.53, '2026-12-06': 259.33, '2026-12-13': 256.86, '2026-12-20': 258.29 } },
  '609': { name: "THROUGHPUT", rates: { '2026-10-04': 49.48, '2026-10-11': 50.03, '2026-10-18': 50.58, '2026-10-25': 51.2, '2026-11-01': 50.63, '2026-11-08': 50.64, '2026-11-15': 51.19, '2026-11-22': 51.72, '2026-11-29': 52.08, '2026-12-06': 51.4, '2026-12-13': 51.88, '2026-12-20': 55.5 } },
};

// LVP function (casual name, as in DEPTS) -> Q3G PPID. Post-Mercury child lines
// (Transfer Out Support, TO Fluid Load, TO RWC) roll into 56 Transfer Out, which
// is how FCLM's PPR aggregates them (ppr.detail.da.transferOut.transferOut.total).
export const Q3G_FN_TO_PPID = {
  // PPR-line functions in IB Support (rated directly on the PPR line)
  'LP Receive': '11',
  'Pallet Receive': '12',
  'Each Receive': '2',
  'Prep Receive': '24',
  'PID Unload': "1",
  'PID Divert': "1",
  'PID Inject': "1",
  'PID Operator': "1",
  'AROS Unload': "1",
  'AROS Operator': "13",
  'AROS CSX Label': "1",
  'AROS Avery': "56",
  'AROS Divert': "56",
  'AROS Sort': "40",
  'AROS Waterspider': "56",
  'Trans Out Overflow': "56",
  'PR Unload': "1",
  'Pallet Build': "13",
  'Pallet Wrap/Lantech': "1",
  'PR Waterspider': "13",
  'IB Pallet EPJ WS': "13",
  'Pallet Auditors': "13",
  'EPJ Spotter': "13",
  'PIT Pallet Build': "13",
  'IB PIT Waterspider': "1",
  'PIT Unloader': "1",
  'EOL Avery': "57",
  'EOL Divert': "56",
  'EOL Sort': "40",
  'EOL Waterspider': "56",
  'Fluid WS': "56",
  'Fluid Load': "56",
  'Sorter Wallbuilder': "56",
  'Jam Clear': "13",
  'Wall Builder': "56",
  'OB EPJ WaterSpider': "57",
  'Pallet Loader': "57",
  'OB PIT Operator': "57",
  'OB EPJ Operator': "57",
  'IB Problem Solve': "13",
  'IB Piles/Multi-ASIN Pallet Receive': "42",
  'ISS': "42",
  'IB TDR': "1",
  'IB Lead/PA': "41",
  'PR PA': "41",
  'IB Training': "13",
  'IB Ambassador': "13",
  'IB Clerk': "1",
  'Fluid Load Sweeper': "59",
  'DA Problem Solve': "59",
  'OB Training': "56",
  'OB Ambassador': "56",
  'Ship Clerk': "57",
  'OB TDR': "57",
  'DA Lead/PA': "58",
};

// NSXD LTC "Expected Rate" per function (cartons/hr). In Q3G mode LVP uses this
// as the fallback rate for a function that has no B3of4 history, so it is still
// planned with hours and takes its share of the line target.
export const Q3G_EXPECTED_FN_RATE = {
  'PID Unload': 300.0,
  'PID Divert': 600.0,
  'PID Inject': 300.0,
  'PID Operator': 1600.0,
  'AROS Unload': 350.0,
  'AROS Operator': 300.0,
  'AROS CSX Label': 350.0,
  'AROS Avery': 350.0,
  'AROS Divert': 233.3,
  'AROS Sort': 116.7,
  'AROS Waterspider': 140.0,
  'PR Unload': 170.0,
  'Pallet Build': 85.0,
  'Pallet Wrap/Lantech': 288.0,
  'PR Waterspider': 340.0,
  'IB Pallet EPJ WS': 680.0,
  'Pallet Auditors': 340.0,
  'EPJ Spotter': 680.0,
  'PIT Pallet Build': 85.0,
  'IB PIT Waterspider': 85.0,
  'PIT Unloader': 85.0,
  'EOL Sort': 100.0,
  'EOL Waterspider': 140.0,
  'Fluid WS': 90.0,
  'Fluid Load': 180.0,
  'Sorter Wallbuilder': 70.0,
  'Wall Builder': 90.0,
  'Pallet Loader': 312.0,
  'OB EPJ Operator': 280.0,
};

// Volume basis per PPR line, in terms of LVP getVols() keys.
export const Q3G_LINE_VOLKEY = {
  '1': 'ibCartons',     // Receive Dock: all IB cartons
  '13': 'ibCartons',    // Receive Support
  '40': 'ibCartons',    // RSR Support (IDRT scanning)
  '41': 'ibCartons',    // IB Lead/PA
  '42': 'ibCartons',    // IB Problem Solve
  '56': 'daCartons',    // Transfer Out (+ TO Fluid Load / TO RWC / TO Support)
  '57': 'daCartons',    // Transfer Out Dock
  '58': 'daCartons',    // TO Lead/PA
  '59': 'daCartons',    // TO Problem Solve
  '11': 'ibCartons',    // LP Receive (LPs ~ cartons basis in LVP)
  '12': 'prPallets',    // Pallet Receive: pallets = PR cartons / CPP
  '2':  'ibCartons',    // Each Receive - Small
  '24': 'ibCartons',    // Prep Recorder - Small
};

// Resolve the Q3G week key for a plan weekStart (YYYY-MM-DD, Sunday).
export function q3gWeekKey(weekStart) {
  return Q3G_WEEKS.includes(weekStart) ? weekStart : null;
}

// Q3G rate for a PPID in a given week, or 0 if the week/line is not in the plan.
export function q3gRate(ppid, weekStart) {
  const wk = q3gWeekKey(weekStart);
  return wk ? (Q3G_LINES[ppid]?.rates?.[wk] || 0) : 0;
}
